import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NewContainerButton from './NewContainerButton';
import addContainer from './../../../actions/addContainer';

const mapStateToProps = ({ estimateBuilder }) => ({
  selectedEstimate: estimateBuilder.uiState.selectedEstimate,
});

const mapDispatchToProps = dispatch => bindActionCreators({ addContainer }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(NewContainerButton);
